export const getPropsDataGridEditing = {
    mode: "popup",
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    useIcons: true,
}

export const getPropsDataGridPopup = {
    showTitle: true,
    title: "Kayıt İşlemi",
    width: "auto",
    height: "auto",

}

export const getPropsTreelist = {
    hoverStateEnabled: true,
    rowAlternationEnabled: true, //satırları açık koyu şeklinde renklendirir    
    height: "50vh",
    width: "auto",
    parentIdExpr: "parentId",
    showRowLines: true,
    showBorders: true,
    columnAutoWidth: true,
    wordWrapEnabled: true,
    autoNavigateToFocusedRow: true,// focusedRowKey set edilince ekranı aktif satıra göre kaydırır    
    focusedRowEnabled: true,
    columnHidingEnabled: true, //ekrana sutun sayılarını ayarlar 
}

export const getPropsDataGrid = {
    hoverStateEnabled: true,
    rowAlternationEnabled: true, //satırları açık koyu şeklinde renklendirir    
    height: "auto",
    width: "auto",
    showRowLines: true,
    showColumnLines: false,
    showBorders: false,
    columnAutoWidth: true,
    //wordWrapEnabled: true,
    autoNavigateToFocusedRow: true,// focusedRowKey set edilince ekranı aktif satıra göre kaydırır    
    focusedRowEnabled: true,
    columnHidingEnabled: true, //ekrana sutun sayılarını ayarlar 

}

export const getPropsPhoneEditor = { mask: '(X00) 000 00 00', maskRules: { X: /[02-9]/ } };

export const getPropsLookupExprForIdName = { valueExpr: "id", displayExpr: "name" }
export const getPropsLookupExprForIdText = { valueExpr: "id", displayExpr: "text" }
export const getRadioEditorOptionHorizontal = {
    layout: "horizontal", valueExpr: "id", displayExpr: "text"
}
export const getRadioEditorOptionIdTextVertical = {
    layout: "vertical", valueExpr: "id", displayExpr: "text"
}

export const getPropsDateEdit = {
    editorType: "dxDateBox",
    dataType: "date",
    format: "shortDate",
    editorOptions: {
        type: "date",
        dateSerializationFormat: "yyyy-MM-dd",
        format: "shortDate",
        showClearButton: true,
        // inputAttr=dateLabel,
        //displayFormat: "shortdate"

        //useMaskBehavior: true, // Cannot read properties of null (reading 'length') hatası verdi, 
        // lazım olan yerde dene, genele koyma
    }
}

export const getPropsTimeEdit = {
    editorType: "dxDateBox",
    dataType: "datetime ",
    format: "shortTime",
    editorOptions: {
        type: "time",
        //dateSerializationFormat: "yyyy-MM-dd"
    }
}

export const getPropsDateTimeEdit = {
    editorType: "dxDateBox",
    dataType: "date",
    format: "shortDateShortTime",
    editorOptions: {
        type: "datetime",
        dateSerializationFormat: "yyyy-MM-dd"
    }
}

export const getSelectBoxPropertiesIdText = {
    valueExpr: "id",
    displayExpr: "text",
    searchExpr: "text",
    searchEnabled: true,
}

export const getSelectBoxPropertiesIdName = {
    valueExpr: "id",
    displayExpr: "name",
    searchExpr: "name",
    searchEnabled: true,
}

export const getPropsDataGridColSpan = { colSpan: 2 }

